// import keepRecordList from '../components/keepRecord/keepRecordList.vue'

export default [
    {
        path: 'keepRecord/keepRecordList',
        component: resolve => require(['@/components/keepRecord/keepRecordList'],resolve),
        name:"KeepRecordList",
        meta:{
            id:'752',
            node:'keepRecord',
            url:'keepRecordList',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/keepRecord.js